import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openWidget } from '../actions/app-state';
import { bindAll } from '../utils/functions';
import DefaultButtonIcon from './DefaultButtonIcon';
import {MESSENGER_BUTTON} from '../constants/dimensions';
import { getFormattedSize } from '../utils/dimensions';
import Icebreaker from "./Icebreaker";

export class MessengerButtonComponent extends Component {
    static propTypes = {
        shown: PropTypes.bool.isRequired,
        unreadCount: PropTypes.number.isRequired,
        buttonWidth: PropTypes.string,
        buttonHeight: PropTypes.string,
        brandColor: PropTypes.string,
        isBrandColorDark: PropTypes.bool,
        buttonIconUrl: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        icebreaker: PropTypes.object,
    };

    static defaultProps = {
        shown: true,
        unreadCount: 0,
    };

    state = {
        icebreakerOpenedBefore: false,
    };

    constructor(...args) {
        super(...args);
        bindAll(this, 'onClick');
    }

    onClick(e) {
        const { dispatch } = this.props;
        e.preventDefault();
        dispatch(openWidget());

        this.setState({
            icebreakerOpenedBefore: true,
        });
    }

    render() {
        const {
            unreadCount,
            shown,
            brandColor,
            isBrandColorDark,
            buttonIconUrl,
            buttonWidth,
            buttonHeight,
            icebreaker,
        } = this.props;

        const style = {
            width: getFormattedSize(buttonWidth) || MESSENGER_BUTTON.DEFAULT_WIDTH,
            height: getFormattedSize(buttonHeight) || MESSENGER_BUTTON.DEFAULT_HEIGHT,
        };

        let content;

        if (buttonIconUrl) {
            content = (
                <div className="messenger-button-icon">
                    <img alt="Smooch Messenger Button" src={buttonIconUrl} />
                </div>
            );
        } else {
            (style.backgroundColor = `#${brandColor}`),
                (content = <DefaultButtonIcon isBrandColorDark={isBrandColorDark} />);
        }

        let unreadBadge;
        if (unreadCount > 0) {
            unreadBadge = <div className="unread-badge">{unreadCount}</div>;
        }

        let icebreakerElement;
        if (icebreaker && icebreaker.text && !this.state.icebreakerOpenedBefore) {
            icebreakerElement = (
                <Icebreaker
                    delay={icebreaker.delay}
                    text={icebreaker.text}
                    styles={icebreaker.styles}
                    buttonStyle={style}
                />
            );
        }

        return (
            <div
                id="messenger-button"
                className={`messenger-button-${shown ? 'shown' : 'hidden'}`}
                style={style}
                onClick={this.onClick}
            >
                {content}
                {unreadBadge}
                {icebreakerElement}
            </div>
    );
    }
}

export default connect(
    ({
        conversations,
        appState: { activeConversationId },
        config: { colors, buttonIconUrl, buttonWidth, buttonHeight, icebreaker },
    }) => {
        const { unreadCount } = conversations[activeConversationId];
        return {
            brandColor: colors.brandColor,
            isBrandColorDark: colors.isBrandColorDark,
            buttonIconUrl,
            buttonWidth,
            buttonHeight,
            unreadCount,
            icebreaker,
        };
    },
    null,
    null,
    { forwardRef: true },
)(MessengerButtonComponent);
